import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { initializeAppInsights } from "common/infrastructure/applicationInsights";
import * as registration from "./serviceWorkerRegistration";
import configureStore from "./redux/store";
import { Provider } from "react-redux";
import { ThemeProvider } from "@material-ui/core/styles";
import theme from "./common/theme/curves-theme";
import "./common/styles/curves.scss";
import "./common/languageHandling/i18n";
import "moment-timezone";
import { createManifest } from "PWA/manifestCreator";
import moment from "moment";
import i18n from "./common/languageHandling/i18n";
import "moment/locale/nb";
import "moment/locale/fi";
import "moment/locale/sv";

initializeAppInsights();
createManifest();

function getDateTimeLocale() {
  switch (i18n.language) {
    case "en":
      return "en";
    case "fi":
      return "fi";
    case "sv":
      return "sv";
    case "no":
      return "nb";
    default:
      "en";
  }
}

moment.locale(getDateTimeLocale(), {
  week: {
    dow: 1,
  },
});

export const store = configureStore();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <React.Suspense fallback="loading...">
          <App />
        </React.Suspense>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
registration.register();
